import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoPassport24 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M9.91667 15.3334H14.0833M14.0833 10.75C14.0833 11.9006 13.1506 12.8334 12 12.8334C10.8494 12.8334 9.91667 11.9006 9.91667 10.75C9.91667 9.59943 10.8494 8.66669 12 8.66669C13.1506 8.66669 14.0833 9.59943 14.0833 10.75ZM6.58333 19.0834H17.4167C17.8769 19.0834 18.25 18.7103 18.25 18.25V5.75002C18.25 5.28979 17.8769 4.91669 17.4167 4.91669H6.58333C6.1231 4.91669 5.75 5.28979 5.75 5.75002V18.25C5.75 18.7103 6.1231 19.0834 6.58333 19.0834Z" stroke={iconColor} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoPassport24;